import { Box, Flex, Heading, Image, Text } from "@chakra-ui/react"; 

export default function ComingSoon() {
     return ( 

        <Box backgroundColor="gray.800">
            <Box bg="white" borderRadius="16px" p={{ base: 6, md: 10 }} 
                maxW="700px" mx="auto" textAlign="center" 
            > 

                <Heading fontSize={{ base: "1.8rem", md: "2rem" }} color="#0B1F33" mb={3} fontWeight="extrabold"> 
                        Multi‑currency Virtual Cards 
                    </Heading> 
                {/* Card Images */} 
                <Flex justify="center" gap={{ base: 4, md: 6 }} mb={8} 
                    direction={{ base: "column", sm: "row" }} align="center" 
                > 
                    <Image src="/virtual-card-1.svg"
                        alt="Swiftchang Virtual Card" w={{ base: "220px", md: "260px" }} 
                        borderRadius="14px" boxShadow="0 8px 20px rgba(0,0,0,0.08)" 
                    /> 
                    <Image src="/virtual-card-2.svg"
                        alt="Swiftchang Virtual Card" w={{ base: "220px", md: "260px" }} 
                        borderRadius="14px" boxShadow="0 8px 20px rgba(0,0,0,0.08)" 
                    /> 
                    
                </Flex> 
                    {/* Text Section */} 
                    
                
                    <Text fontSize="1rem" color="#080808" maxW="600px" mx="auto" > 
                        Spend globally with ease. Our multi‑currency virtual cards let you shop, 
                        subscribe, and pay online in multiple currencies — securely and instantly. <br /> 
                    <strong fontSize={{ base: "2rem", md: "2.5rem" }}  
                        mb={2} color="#0b0b0b" > Coming Soon! </strong>  
                    </Text> 
            </Box>
        </Box> ); }